<div class="fixed top-0 z-40 w-full">
  <div class="bg-white h-[34px] flex justify-center items-center">
    @if (logoUrl()) {
      <sc-button
        variant="text"
        [padding]="false"
        [ariaLabel]="'Go to Let’s go Mobile homepage'"
        (clicked)="handleLogoRedirect()"
        class="w-fit"
      >
        <img
          [src]="logoUrl().mobileImage?.url | scCmsImage"
          class="h-6"
          alt=""
          aria-hidden="true"
        />
      </sc-button>
    }
  </div>

  @if (!isPortingBlocked()) {
    <div class="px-6 h-[68px] bg-primaryRed items-center grid grid-cols-[32px_auto_32px]">
      @if (!hideNav()) {
        <div class="flex flex-col items-center">
          <sc-button
            variant="icon"
            id="burgerMenuToggler"
            class="size-6 flex items-center burger-menu"
            [attr.aria-expanded]="isOpen()"
            (clicked)="toggleMenu()"
          >
            <sc-svg name="mobile-menu" size="w-8 h-8"></sc-svg>
          </sc-button>
          <label for="burgerMenuToggler" class="text-white font-semibold text-xs cursor-pointer">{{
            'shared.menu' | scTranslate | async
          }}</label>
        </div>
        <div
          class="text-white text-mobileLg tablet:text-tabletLg font-light desktop:text-desktopLg flex justify-center text-center mx-2"
        >
          {{ title() | scTranslate | async }}
        </div>
      }

      @if (!isB2B()) {
        <sc-button
          variant="icon"
          size="small"
          (click)="toggle()"
          class="rounded-full bg-white col-start-3"
        >
          {{ initials() && initials().replaceAll('.', '') }}
        </sc-button>
      }
      @if (isB2B()) {
        <sc-button variant="icon" size="small" (click)="toggle()" class="col-start-3">
          <sc-svg name="profile-avatar" size="w-11 h-11"></sc-svg>
        </sc-button>
      }
    </div>
  }
</div>

@if (isOpenProfile()) {
  <sc-mobile-profile #mobileProfile (isOpen)="closeProfileModal()"></sc-mobile-profile>
}

@if (isOpen()) {
  <div class="bg-white w-full fixed left-0 top-[102px] bottom-0 z-50">
    <div class="h-full overflow-auto flex flex-col">
      <div class="p-2">
        <sc-msisdn-preview></sc-msisdn-preview>
      </div>

      <div class="font-light text-black divide-y bg-white menu sidebar-links">
        @for (linkGroup of linkNavigationList(); track $index) {
          <div class="hover:bg-secondaryRed">
            <div
              class="px-6 h-[72px] flex justify-between cursor-pointer"
              [ngClass]="{
                '!bg-primaryRed text-white font-semibold': isParentLinkActive(linkGroup),
              }"
            >
              <a
                class="w-full h-full flex items-center text-mobileMd tablet:text-tabletMd"
                (click)="setSelectedPath(linkGroup.path)"
                [routerLink]="linkGroup.path"
              >
                {{ linkGroup.label | scTranslate | async }}
              </a>
              @if (linkGroup.subLinks.length) {
                <div class="flex items-center">
                  <sc-button
                    variant="icon"
                    [class.rotate-180]="selectedPath === linkGroup.path"
                    class="size-10"
                    (click)="toggleSubLinks(linkGroup)"
                    title="{{ 'shared.showSubLinks' | scTranslate | async }}"
                  >
                    <sc-svg name="arrow-down" size="w-5 h-5"></sc-svg>
                  </sc-button>
                </div>
              }
            </div>
            @if (selectedPath === linkGroup.path) {
              @for (sublink of linkGroup.subLinks; track $index) {
                <div>
                  <a
                    [routerLink]="sublink.path"
                    routerLinkActive="border-l-[red] font-semibold tablet:font-semibold "
                    class="border-l-2 h-[72px] flex items-center pl-[22px] bg-[#F0DBDB] text-mobileMd tablet:text-tabletMd hover:bg-secondaryRed"
                  >
                    {{ sublink.label | scTranslate | async }}
                  </a>
                </div>
              }
            }
          </div>
        }
      </div>
    </div>
  </div>
}
